import React, { useState, memo, Suspense, useMemo } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import ImprovedGlobe from './ImprovedGlobe'; // New improved globe implementation
import Chart from "react-google-charts";
import GlobeSkeleton from './GlobeSkeleton';

// Combined Map Component
const DynamicWorldMap = ({ isUser = false, data, countries, hoveredCountry: propHoveredCountry, setHoveredCountry }) => {
  // Use prop if provided, else local (for non-WorldMap uses)
  const [localHoveredCountry, setLocalHoveredCountry] = useState(null);
  const hoveredCountry = propHoveredCountry !== undefined ? propHoveredCountry : localHoveredCountry;
  const setCountry = setHoveredCountry || setLocalHoveredCountry;
  const webglAvailable = useMemo(() => {
    try {
      const canvas = document.createElement('canvas');
      return Boolean(canvas.getContext('webgl') || canvas.getContext('webgl2'));
    } catch (error) {
      return false;
    }
  }, []);

  const options = {
    // colorAxis: { colors: ['#355FD8'] }, // Custom colors
    colorAxis: { colors: ["#DA1C00"] }, // Custom colors
    is3D: true,

    tooltip: { trigger: "none" }, // Disable tooltip // Tooltip style
  };
  const chartEvents = [
    {
      eventName: "select",
      callback: ({ chartWrapper }) => {
        const chart = chartWrapper.getChart();
        const selection = chart.getSelection();
        if (selection.length === 0) return;
        const region = data[selection[0].row + 1];
      },
    },
  ];

  // 3D Globe for authenticated users with Suspense
  if (isUser && countries && webglAvailable) {
    return (
      <div className="my-2 py-5 bg-white rounded-lg flex justify-center">
        <div className="md:w-3/4 w-full">
          <div style={{ height: '80vh', overflow: 'hidden' }}>
            <Suspense fallback={<GlobeSkeleton />}>
              <Canvas
                camera={{
                  position: [0, 0, 350],
                  fov: 45,
                  near: 0.1,
                  far: 1000,
                }}
              >
                <ambientLight intensity={3} />
                <directionalLight position={[5, 5, 5]} intensity={1} />
                <pointLight position={[10, 10, 10]} intensity={1.5} />
                <ImprovedGlobe countries={countries} setHoveredCountry={setCountry} />
                <OrbitControls
                  enableZoom={false}
                  minDistance={150}
                  maxDistance={400}
                  enableRotate={true}
                  enablePan={false}
                  rotateSpeed={0.5}
                  zoomSpeed={0.8}
                />
              </Canvas>
            </Suspense>
            {hoveredCountry && (
              <div
                style={{
                  position: 'absolute',
                  top: 10,
                  left: 10,
                  color: 'white',
                  background: 'rgba(0, 0, 0, 0.5)',
                  padding: '5px',
                }}
              >
                {hoveredCountry}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // 2D Map for non-users
  return (
    <div className="my-2 py-5 bg-white rounded-lg flex justify-center">
      <div className="md:w-3/4 w-full">
        <Chart
          chartEvents={chartEvents}
          chartType="GeoChart"
          width="100%"
          height="400px"
          data={data}
          options={options}
        />
      </div>
    </div>
  );
};

export default memo(DynamicWorldMap);